
import { STISCScanFailed } from "@/domain/entities/StiSc";
import { prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import XLSX from "xlsx";

export class Props {
  data = prop<STISCScanFailed[]>({
    default: () => [],
    required: true,
    type: Array
  });
}

export default class ScanFailedCard extends Vue.with(Props) {
  get languageKey() {
    return AccountController.accountData.accountIsForeign ? "en" : "id"
  }

  get dataKeyTranslated() {
    return {
      sttNo: this.$t("Nomor STT"),
      failedReason: this.$t("Alasan gagal scan"),
      sttFailedScan: this.$t("STT gagal scan")
    }
  }

  XLSX = XLSX;
  downloadExcel() {
    const data = this.XLSX.utils.json_to_sheet(
      this.data.map((d: any) => ({
        [this.dataKeyTranslated.sttNo]: d.sttNo,
        [this.dataKeyTranslated.failedReason]: d?.errorMessage?.[this.languageKey] ? d.errorMessage[this.languageKey] : d.errorMessage
      }))
    );
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, data, this.dataKeyTranslated.sttFailedScan);
    this.XLSX.writeFile(wb, `${this.dataKeyTranslated.sttFailedScan}.xlsx`);
  }
}
